<template>
	<section :id="data.id" class="content-boxes">
		<ContentBox
			v-for="(contentBox, index) in contentBoxes"
			:key="`${contentBox.id}-${index}`"
			:id="contentBox?.sys?.id"
			:content="contentBox.fields"
		/>
	</section>
</template>

<script setup>
const props = defineProps({
	data: {
		type: Object
	}
});

const contentBoxes = computed(() => {
	return props?.data?.data?.boxes;
});
</script>